import { BaseService } from './BaseService';
import type { UserDto } from '../types/auth';

/**
 * Authentication service for B2C-only auth.
 * Handles getCurrentUser and ensureCurrentUser (post-B2C login provisioning).
 */
export class AuthService extends BaseService {
  /**
   * Gets the current authenticated user. Optionally pass a token (e.g. right after login) so the request uses it without relying on stored auth.
   */
  async getCurrentUser(token?: string): Promise<UserDto> {
    const config = token ? { headers: { Authorization: `Bearer ${token}` } } : undefined;
    return this.get<UserDto>('/users/me', config);
  }

  /**
   * Ensures the current user and tenant/TenantUser records exist on the backend: create user if not exist (from token claims), and create Tenant + TenantUser entries from extension_Organizations (orgName~orgId~tenantId, comma-separated). Called on B2C login success.
   */
  async ensureCurrentUser(token: string): Promise<void> {
    await this.post<void>('/users/me/ensure', undefined, {
      headers: { Authorization: `Bearer ${token}` },
    });
  }
}

export const authService = new AuthService();
